<template>
  <div>
    <div class="section" id="cont">
      <section
        class="columns is-fullheight is-fullwidth"
        style="transition: all 0.3s ease 0s !important;"
      >
        <div class="column" style="transition: all 0.3s ease 0s !important;">
          <div v-if="dataLider">
            <section>
              <!--  Header  -->
              <section
                id="views"
                class="hero title-card"
                v-if="dataLider.empleado"
              >
                <div class="hero-body">
                  <div class="container">
                    <h1 class="title">
                      {{ dataLider.empleado.nombre }}
                    </h1>
                    <h2 class="subtitle">
                      {{ dataLider.empleado.cargo }} -
                      {{ dataLider.empleado.dependencia }} -
                      {{ dataLider.empleado.email }}
                    </h2>
                  </div>
                  <div>
                    <span>Fecha de diagnóstico</span>
                    <h4 class="has-text-dark">
                      {{ dateProcess(infoProcess.date) }}
                    </h4>
                  </div>
                </div>
              </section>

              <!--  Data  -->
              <div class="columns fecha">
                <div class="column button-ctx">
                  <a
                    v-if="tokenUser && tokenUser.admin"
                    href="javascript:void(0)"
                    class="button is-small is-dark"
                    :class="this.validCtx ? 'is-loading' : ''"
                    :disabled="this.validCtx"
                    v-on:click="switchContext"
                    style="gap: 5px"
                  >
                    <i class="material-icons">language</i>
                    <span
                      >{{
                        generalContext.status ? "Ocultar" : "Mostrar"
                      }}
                      Contexto general</span
                    >
                  </a>
                </div>
              </div>

              <!-- SubHeader - Cards Info  -->
              <section style="margin-top: 30px">
                <div class="container columns has-text-centered">
                  <div class="column is-parent is-vertical">
                    <div class="box box-sub">
                      <h1 class="is-size-5 has-text-weight-bold">
                        Participación
                      </h1>
                      <span class="is-size-3 has-text-dark" v-if="infoProcess"
                        >{{
                          (infoProcess.participation || 0).toFixed(0)
                        }}%</span
                      >
                    </div>
                  </div>
                  <div class="column is-parent is-vertical">
                    <div class="box box-sub">
                      <h1 class="is-size-5 has-text-weight-bold">
                        Encuestados
                      </h1>
                      <span class="is-size-4" v-if="infoProcess">{{
                        infoProcess.totalParticipation
                      }}</span>
                    </div>
                  </div>
                  <div class="column is-parent is-vertical">
                    <div class="box box-sub">
                      <h1 class="is-size-5 has-text-weight-bold">
                        Sin Consentimiento
                      </h1>
                      <span class="is-size-4" v-if="infoProcess">{{
                        infoProcess.noConsent
                      }}</span>
                    </div>
                  </div>
                </div>
              </section>

              <!-- SubHeader - Ranges -->
              <div ref="stickySentinel" class="sticky-sentinel"></div>
              <section
                ref="subHeader"
                class="sub-header"
                :class="{ 'is-stuck': stuck }"
              >
                <div class="column" style="padding-left: 0;">
                  <table class="is-flex table-radius-6" style="width: 100%">
                    <tr
                      v-tooltip.bottom-start="
                        tooltipRango(1, 'Menos del 50 de Líder PHD')
                      "
                    >
                      <div class="p-2 rango1"></div>
                      <td class="p-2">Líder con prioridad de intervención</td>
                    </tr>
                    <tr
                      v-tooltip.bottom-start="
                        tooltipRango(2, 'Entre el 50 y 59 de Líder PHD')
                      "
                    >
                      <div class="p-2 rango2"></div>
                      <td class="p-2">Líder con oportunidad de mejora</td>
                    </tr>
                    <tr
                      v-tooltip.bottom-start="
                        tooltipRango(3, 'Entre el 60 y 69 de Líder PHD')
                      "
                    >
                      <div class="p-2 rango3"></div>
                      <td class="p-2">Líder en desarrollo</td>
                    </tr>
                    <tr
                      v-tooltip.bottom-start="
                        tooltipRango(4, 'Entre el 70 y 79 de Líder PHD')
                      "
                    >
                      <div class="p-2 rango4"></div>
                      <td class="p-2">Líder competente</td>
                    </tr>
                    <tr
                      v-tooltip.bottom-start="
                        tooltipRango(5, 'Entre el 80 y 89 de Líder PHD')
                      "
                    >
                      <div class="p-2 rango5"></div>
                      <td class="p-2">Líder experta(o)</td>
                    </tr>
                    <tr
                      v-tooltip.bottom-start="
                        tooltipRango(6, 'Mayor de 90 Líder PHD')
                      "
                    >
                      <div class="p-2 rango6"></div>
                      <td class="p-2">Líder PHD</td>
                    </tr>
                  </table>
                </div>
              </section>

              <!-- SubHeader - General Context -->
              <Transition name="fade">
                <section
                  v-if="generalContext.status"
                  class="content-generalCtx"
                >
                  <div
                    class="ranking"
                    :data-number="generalContext.headers.position"
                  >
                    <img
                      src="@/assets/icons/shield.svg"
                      alt="ranking icon"
                      width="120"
                    />
                    <span
                      v-tooltip.right="
                        'Posición actual frente al total de líderes'
                      "
                      class="tag"
                      >Posición Líder</span
                    >
                  </div>
                  <div class="hero hero-context">
                    <div class="hero-body has-text-centered">
                      <div class="container">
                        <nav class="level">
                          <div class="level-item has-text-centered">
                            <div>
                              <p class="heading">Líderes</p>
                              <p class="title">
                                {{ generalContext.headers.leaders || 0 }}
                              </p>
                            </div>
                          </div>
                          <div class="level-item has-text-centered">
                            <div>
                              <p class="heading">Empresas</p>
                              <p class="title">
                                {{ generalContext.headers.clients || 0 }}
                              </p>
                            </div>
                          </div>
                          <div class="level-item has-text-centered">
                            <div>
                              <p class="heading">Encuestados</p>
                              <p class="title">
                                {{ generalContext.headers.data || 0 }}
                              </p>
                            </div>
                          </div>
                          <div class="level-item has-text-centered">
                            <div>
                              <p class="heading">Años</p>
                              <p class="title">
                                {{ generalContext.headers.min || "--" }} -
                                {{ generalContext.headers.max || "--" }}
                              </p>
                            </div>
                          </div>
                        </nav>
                      </div>
                    </div>
                  </div>
                </section>
              </Transition>

              <!--  Section Views  -->
              <div id="views">
                <div class="container">
                  <section v-if="dataLider">
                    <ResulLiderParte1
                      ref="childComponent1"
                      :dataLider="dataLider"
                      :generalContext="generalContext"
                    ></ResulLiderParte1>
                  </section>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import ResulLiderParte1 from "./ResultadoLider/ResulLiderParte1.vue";
import { mapState } from "vuex";
import json from "./calificacionLider.json";

function escapeHtml(str) {
  return String(str).replace(
    /[&<>"']/g,
    (ch) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[ch]),
  );
}

export default {
  data() {
    return {
      dataLider: {},
      infoProcess: {},
      processComp: null,
      generalContext: {
        status: false,
        data: {},
        headers: {},
      },
      cambio: 0,
      calificacionesGeneral: json.calificaciones.general,
      stuck: false,
    };
  },
  computed: {
    ...mapState(["idtoken", "empresa", "isOculto", "tokenUser"]),
    routestateid() {
      return this.$route.params.liderid;
    },
    validCtx() {
      return (
        this.isEmpty(this.generalContext.data) &&
        this.isEmpty(this.generalContext.headers)
      );
    },
  },
  async beforeMount() {
    if (this.$route.name !== "sharelider") {
      const comparison = await apiServices.get(
        `/getComparison/${this.$route.params.procesoid}`,
      );

      if (comparison.data) {
        this.processComp = comparison.data;
      }
    }
  },
  methods: {
    // Ranges legend
    tooltipRango(r, condicion) {
      const definicion = this.calificacionesGeneral[r] || "";
      const content = `
        <div class="lrtt-condicion">${escapeHtml(condicion)}</div>
        <div class="lrtt-def">${escapeHtml(definicion)}</div>
      `;
      return { content, classes: ["lider-rango-tooltip"], html: true };
    },
    async fetchShared() {
      try {
        const data = {
          relacionid: this.$route.params.relacionid,
          liderid: this.$route.params.liderid,
          procesoid: this.$route.params.procesoid,
        };
        const result = await apiServices.post(`/resultliderfree`, data);

        if (result.data) {
          this.dataLider = result.data;
          this.infoProcess = result.data.infoProcess;
          this.autoScroll();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async traeData() {
      let result;
      try {
        if (this.$route.name !== "sharelider") {
          result = await apiServices.get(
            `/resultlider/${this.$route.params.procesoid}/${this.$route.params.liderid}`,
          );

          this.dataLider = result.data;
          this.infoProcess = result.data.infoProcess;
          this.cambio === 0 ? (this.cambio = 1) : (this.cambio = 0);
          result.data.cambio = this.cambio;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGeneralContext() {
      try {
        const result = await apiServices.get("/generalContext/1");

        if (result.data) {
          this.generalContext.data = result.data.context;
          this.generalContext.headers = result.data.headers;
          this.generalContext.headers.position = this.getPosition(
            result.data.headers,
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    switchContext() {
      if (this.validCtx) return;
      this.generalContext.status = !this.generalContext.status;
      this.dataLider.cambio
        ? (this.dataLider.cambio = 0)
        : (this.dataLider.cambio = 1);
    },
    getPosition(headers) {
      const lidert = this.dataLider.colaboradores.liderT.e;
      if (lidert == null) return "-";

      const position = headers.ranking.avg_lidert_e.filter((value) => {
        if (value.proceso_id_mongo === this.$route.params.procesoid)
          return false;
        return value.avg_lidert_e > lidert;
      }).length;

      return position + 1;
    },
    autoScroll() {
      setTimeout(() => {
        let el = document.getElementById("views");
        el.scrollIntoView({ behavior: "smooth" });
      });
    },
    dateProcess(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "long", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
    isEmpty(ele) {
      if (ele === undefined) return true;
      if (typeof ele === "object") return Object.keys(ele).length === 0;
      return ele.length === 0;
    },
    // Sticky ranges legend
    initStickyObserver() {
      this.$nextTick(() => {
        const sentinel = this.$refs.stickySentinel;
        if (!sentinel || this._stickyObserver) return;
        this._stickyObserver = new IntersectionObserver(
          ([entry]) => {
            this.stuck = !entry.isIntersecting;
          },
          { threshold: 0 },
        );
        this._stickyObserver.observe(sentinel);
      });
    },
  },
  mounted() {
    this.initStickyObserver();
  },
  beforeDestroy() {
    if (this._stickyObserver) this._stickyObserver.disconnect();
  },
  created() {
    if (this.idtoken) {
      this.getGeneralContext();
      this.traeData();
    } else {
      this.fetchShared();
    }
  },
  watch: {
    idtoken(newv) {
      if (newv && !this.$route.params.relacionid) {
        this.traeData();
      }
    },
    dataLider(ne) {
      if (ne) this.getGeneralContext();
    },
  },
  components: {
    ResulLiderParte1,
  },
};
</script>

<style scoped lang="scss">
.table-radius-6 {
  justify-content: space-between;
}

.table-radius-6 > tr:last-child {
  border-top-right-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}

.table-radius-6 > tr:first-child {
  border-top-left-radius: 6px !important;
  border-bottom-left-radius: 6px !important;
}

.table-radius-6 > tr {
  display: flex;
  line-height: 15px;
  font-size: 14px;
}

.table-radius-6 tr > td {
  width: 150px;
  margin: auto;
}

.table-radius-6 tr > div {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.sticky-sentinel {
  height: 1px;
  width: 100%;
}

.sub-header {
  position: sticky;
  top: 0;
  z-index: 40;
  margin-bottom: 5px;
  background-color: white;
  transition: padding 0.18s ease, box-shadow 0.18s ease;
}

.sub-header .table-radius-6 > tr {
  font-size: 12px;
  line-height: 12px;
}

.sub-header .p-2 {
  padding-top: 0.05rem;
  padding-bottom: 0.05rem;
}

.sub-header.is-stuck {
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.sub-header.is-stuck .table-radius-6 > tr {
  flex: 1 1 0;
  justify-content: center;
}

.is-primary {
  color: #134f5c !important;
}

.is-red {
  color: red;
}

.fecha {
  margin-top: 10px;
  margin-left: 2px;
}

.fecha .is-small {
  border-radius: 4px;
}

.fecha .button-ctx {
  display: flex;
  justify-content: end;
}

.box-sub {
  height: 118px !important;
}

.content-generalCtx {
  position: relative;
  display: flex;
  margin-top: 25px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    top: -5px;
  }
}

.hero-context {
  border-radius: 10px !important;
  background-color: #d27ff93e !important;
  width: 100%;
  @media screen and (max-width: 768px) {
    padding-top: 20px;
    border-top: #510087 solid;
  }
}

.hero-context .hero-body {
  padding: 35px !important;
}

.ranking {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  @media screen and (max-width: 768px) {
    bottom: -39px;
    margin-right: 0 !important;
  }
}

.ranking .tag {
  position: relative;
  background-color: #510087;
  font-weight: 800;
  color: white;
  top: -12px;
}

.ranking::before {
  content: attr(data-number);
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  font-size: 2rem;
  font-weight: bold;
  pointer-events: none;
}

.title-card {
  border-radius: 10px !important;
  background-color: #f3f3f3 !important;
}

.title-card .hero-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}

/* Backgrounds */

.rango1 {
  background-color: #f4cdcd !important;
  color: gray;
}

.rango2 {
  background-color: #facca5 !important;
  color: gray;
}

.rango3 {
  background-color: #fff2cc !important;
  color: gray;
}

.rango4 {
  background-color: #d9ead3 !important;
  color: gray;
}

.rango5 {
  background-color: #a2c4c9 !important;
  color: white;
}

.rango6 {
  background-color: #c8d9f7 !important;
  color: white;
}

.rango0 {
  background-color: rgba(175, 174, 174, 0.81);
}

@media (max-width: 768px) {
  .title-card .hero-body {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .title-card .hero-body .container {
    width: 100%;
  }

  .title-card .title {
    font-size: 1.1rem !important;
    line-height: 1.4;
  }

  .title-card .subtitle {
    font-size: 0.9rem !important;
  }

  .title-card .hero-body > div:last-child {
    text-align: center;
  }

  .title-card .hero-body > div:last-child span {
    font-size: 0.8rem;
  }

  .title-card .hero-body > div:last-child h4 {
    font-size: 0.95rem;
  }
}

@media (max-width: 1023px) {
  .table-radius-6 {
    flex-wrap: wrap !important;
    gap: 2px 0;
  }
  .table-radius-6 > tr {
    flex: 0 0 50%;
  } // 2 columnas × 3 filas
  .table-radius-6 tr > td {
    width: auto;
    margin: 0 !important;
  }
}
</style>

<!-- Non-scoped: v-tooltip renders at <body>, el estilo del tooltip debe ser global. -->
<style lang="scss">
.lider-rango-tooltip {
  max-width: 340px !important;

  .tooltip-inner {
    background: #0f0f0f;
    text-align: left;
    padding: 10px 12px;
    border-radius: 10px;
  }
  .tooltip-arrow {
    border-color: #0f0f0f;
  }

  .lrtt-condicion {
    font-weight: 700;
    font-size: 12.5px;
    color: #fff;
    margin-bottom: 6px;
  }
  .lrtt-def {
    font-size: 11.5px;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.9);
    white-space: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/ResultLider.vue